import React, { useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Blacknavtop from "../../components/Navbar/Blacknavtop";
import Footer from "../../components/footer/main";
import Sharebtn from "../../components/Sharebtn/share";
import "./services.css";
import { Link } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";

const Services = (props) => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <div className="">
      <Blacknavtop />
      <Navbar />
      {/* <div className=""></div> */}
      <div className="pt_10rem bg_smoke">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-xs-12">
              <br />
              <br />
              <br />

              <h1 data-aos="fade-right" className="fs25 ">
                LET <span className="tblue ">PROFESSIONALS</span>
                <br /> HANDLE YOUR FINANCE
              </h1>
              <p data-aos="fade-right" data-aos-duration="1000" className="fs12 tgrey">
                Get your accounts done in just 1 click and save big!
              </p>
              <a style={{ textDecoration: "none" }} href="#service">
                <p data-aos="zoom-in" className="Get_started pder">
                  View Services <i class="fas fa-arrow-right"></i>{" "}
                </p>
              </a>
            </div>
            <div className="col-lg-6 col-xs-12">
              <img src={require("../../Assets/accountant.svg")} />
            </div>
          </div>
        </div>
      </div>

      <br />
      <br />
      <Shortservice />
      <div className="container">
        <br />
        <br />
        <div id="service"></div>

        <h3 className="tgrey ">SERVICES</h3>
        <br />
        <br />
        <div className="row">
          <div className="col-lg-6 col-xs-12">
            <Servicediv
              image="tax.svg"
              head="TAX"
              link="true"
              serviceLink="/services/tax"
              text="Get highest tax benefits from our professionals. Talk to our professional and get started now!"
            />
          </div>
          <div className="col-lg-6 col-xs-12">
            <Servicediv
              image="accounting.svg"
              head="GST"
              link="false"
              model="gst"
              serviceLink="https://calendly.com/ca_labs/general"
              text="GST is new and not everyone is good at it. Consult with us and get the utmost benefits."
            />
          </div>
          <div className="col-lg-6 col-xs-12">
            <Servicediv
              image="audit.svg"
              head="AUDIT"
              link="false"
              serviceLink="https://calendly.com/ca_labs/general"
              text="Our team of professionals will conduct thorough audit for you or your clients."
            />
          </div>
          <div className="col-lg-6 col-xs-12">
            <Servicediv
              image="enterprise.svg"
              head="COMPANY REGISTRATION"
              link="true"
              serviceLink="/services/company-registration"
              text="Get your startup/company registered by just a click and focus on the work."
            />
          </div>
        </div>
      </div>
      <Readytostart />
      <FAQ />
      <Footer />
      <Sharebtn />
    </div>
  );
};

const Servicediv = (props) => {
  return (
    <div className="service_div">
      <div className="row">
        <div className="col-4">
          <img width="80%" className="pl_10 pt_20" src={require(`../../Assets/${props.image}`)} />
        </div>
        <div className="col-8 p_10">
          <h2 className="fontfam">{props.head}</h2>
          <p className="pt_5">{props.text}</p>
          <br />

          <a style={{ textDecoration: "none" }} target="_blank" href={props.serviceLink}>
            <p className="Get_started pder">
              Get Started <i className="fas fa-arrow-right"></i>{" "}
            </p>
          </a>
        </div>
      </div>
    </div>
  );
};

const Shortservice = () => {
  return (
    <div className="container" style={{ marginTop: "4rem", marginBottom: "3rem" }}>
      <div className="row ">
        <div className="col-lg-4">
          <div className="shortservice_div">
            <img
              className="shortservice_img"
              src={require("../../Assets/shield.svg")}
              width="60px"
            />
            <h2 className="shortservice_h2">Your data is Safe and Private</h2>
            <p className="text-grey">
              Your data like form16 and others will never be shared with anyone whatsover.
            </p>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="shortservice_div">
            <img
              className="shortservice_img"
              src={require("../../Assets/save-money.svg")}
              width="70px"
            />
            <h2 className="shortservice_h2">Save Maximum on Tax</h2>
            <p className="text-grey">
              Our accountants and tax experts can help you save maximum on tax without any hassle.
            </p>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="shortservice_div">
            <img
              className="shortservice_img"
              src={require("../../Assets/customer-service.svg")}
              width="70px"
            />
            <h2 className="shortservice_h2">Expert Assistance anytime</h2>
            <p className="text-grey">
              Our customers are everything for us. We will help your queries anytime without any
              trouble.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const FAQ = () => {
  return (
    <div class="container">
      <br />
      <br />
      <br />
      <h1 className="">Frequently Asked Questions</h1>
      <br />
      <br />

      <div className="panel-group" id="accordion">
        <div className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">
              <a
                className="accordion-toggle  faqa"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapseOne"
              >
                How much do you charge?
              </a>
            </h4>
          </div>
          <div id="collapseOne" className="panel-collapse  in">
            <div className="panel-body">
              Our fees is low compared to our competitors. We provide a nominal fees starting from
              199 INR for consultancy. Our each service has different price and starts from an
              average of 999 INR.
            </div>
          </div>
        </div>
        <div className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">
              <a
                className="accordion-toggle  faqa"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapseTen"
              >
                How much time does it take?
              </a>
            </h4>
          </div>
          <div id="collapseTen" className="panel-collapse ">
            <div className="panel-body">
              We will contact you within 3 hours and most of our services are done within 3-7 days.
            </div>
          </div>
        </div>
        <div className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">
              <a
                className="accordion-toggle  faqa"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapseEleven"
              >
                How to contact us?
              </a>
            </h4>
          </div>
          <div id="collapseEleven" className="panel-collapse ">
            <div className="panel-body">
              You can schedule an online meet with us or can whatsapp/call us at our number:
              8851856910. You can email us for quotes and enquiries at : mydevcrew@gmail.com
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Readytostart = () => {
  return (
    <div style={{ padding: "10px" }}>
      <div className="container tostartdiv">
        <div className="row">
          <div className="col-lg-8">
            <h1 className="tostart_h1 font-weight-bold">Ready to get financial stability?</h1>
            <div>
              <br />
              <a
                style={{ textDecoration: "none", color: "black" }}
                href="https://calendly.com/ca_labs/general"
                target="_blank"
              >
                <button type="button" class="btn btn-primary fullbtn mr7">
                  Contact us
                </button>
              </a>
              <a style={{ textDecoration: "none" }} href="#service">
                <button type="button" class="btn btn-outline-primary halfbtn">
                  View services <i class="fas fa-arrow-right"></i>
                </button>
              </a>
            </div>
          </div>
          <div className="col-lg-4">
            <img src={require("../../Assets/start.svg")} width="75%" className="desktop_view" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
